import BasedCard from "../Display/BasedCard";
import styled, { keyframes } from "styled-components";
import { Row, Col } from "react-bootstrap";
import WorkExp from "../Display/WorkHisCard";
import { useState } from "react";
import TechStack from "../Display/TechStackCard";

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const ProfileImageWrapper = styled.div`
  position: relative;
  display: inline-block;

  &::before {
    content: "";
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    background: linear-gradient(45deg, #ff003c, #fea794, #ff003c, #fea794);
    background-size: 300% 300%;
    animation: ${gradientAnimation} 4s ease infinite;
    border-radius: 50%;
    z-index: -1;
  }
`;

const ProfileImage = styled.img`
  border: 3px solid rgba(0, 0, 0, 0.8);
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(255, 0, 60, 0.4);
  }
`;

const NameTitle = styled.h2`
  background: linear-gradient(135deg, #ff003c 0%, #fea794 50%, #ff6b6b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 8px;
`;

const RoleTitle = styled.div`
  background: linear-gradient(90deg, rgba(255, 0, 60, 0.15), transparent);
  border-left: 3px solid #ff003c;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 0 8px 8px 0;
`;

const RoleText = styled.span`
  color: #fea794;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

const OrganizationText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  letter-spacing: 1px;
  margin-top: 8px;
  margin-bottom: 0;
`;

const Greeting = styled.span`
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  display: block;
  margin-bottom: 8px;
`;

const SummaryTitle = styled.h5`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: "";
    width: 20px;
    height: 2px;
    background: linear-gradient(90deg, #ff003c, #fea794);
  }
`;

const SummaryText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  line-height: 1.7;
  margin: 0;
`;

const StyledDivider = styled.hr`
  background: linear-gradient(90deg, #ff003c, transparent);
  height: 1px;
  border: 0;
  margin: 12px 0;
  opacity: 0.5;
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 255, 136, 0.1);
  border: 1px solid rgba(0, 255, 136, 0.3);
  color: #00ff88;
  font-size: 11px;
  padding: 4px 12px;
  border-radius: 20px;
  margin-top: 12px;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    background: #00ff88;
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

function Profile() {
  const [isHover, setIsHover] = useState(false);

  return (
    <>
      <Row className="mt-2 mb-2 pb-5">
        <Col md={3} className="pr-md-0">
          <BasedCard>
            <div className="text-center d-flex flex-column align-items-center justify-content-center h-100">
              <ProfileImageWrapper>
                <ProfileImage
                  src={window.location.origin + "/31264504.png"}
                  alt="Profile"
                  className={`rounded-circle ${isHover ? "animate__animated animate__pulse" : ""}`}
                  width="140"
                  onMouseEnter={() => setIsHover(true)}
                  onMouseLeave={() => setIsHover(false)}
                />
              </ProfileImageWrapper>
              <StatusBadge>Available for opportunities</StatusBadge>
            </div>
          </BasedCard>
        </Col>
        <Col md={5} className="pr-md-0 mt-2 mt-md-0">
          <BasedCard>
            <div className="px-4 py-3">
              <Greeting>Hello, I am</Greeting>
              <NameTitle>Withaya Thingakruea</NameTitle>
              <RoleTitle>
                <RoleText>Deputy Manager</RoleText>
                <OrganizationText>
                  Digital Technology Department
                  <br />
                  The Federation of Thai Industries
                </OrganizationText>
              </RoleTitle>
            </div>
          </BasedCard>
        </Col>
        <Col md={4} className="mt-3 mt-md-0">
          <BasedCard>
            <div className="px-4 py-3">
              <SummaryTitle>Professional Summary</SummaryTitle>
              <StyledDivider />
              <SummaryText>
                Tech leader with{" "}
                <strong style={{ color: "#fea794" }}>7+ years</strong> of
                experience in full-stack development, system architecture, and
                team management. Passionate about building scalable digital
                solutions and driving organizational digital transformation.
              </SummaryText>
            </div>
          </BasedCard>
        </Col>
        <WorkExp />
        <TechStack />
      </Row>
    </>
  );
}

export default Profile;
